import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  assignedUserList: [],
}

////////////////////////////////////ASSIGNEE USER LIST////////////////////////////////////////////

export const getAllAssigneeUser: any = createAsyncThunk(
  '/getAllAssigneeUser',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/assignedUserListforSuperAdmin`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    return response.data
  }
)

export const getAllAssigneeUserExport: any = createAsyncThunk(
  '/getAllAssigneeUser/export',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/assignedUserListforSuperAdmin/export`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

export const UpdateAssigneTo: any = createAsyncThunk(
  '/UpdateAssigneTo',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/assignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deallocateUser: any = createAsyncThunk(
  '/deallocateStaff',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}admin/unassignedUserbySuperAdmin`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(getAllAssigneeUser({userId: data?.staffId}))
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const UpdateStatusForOwner: any = createAsyncThunk(
  '/updateStatusForOwner',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)

const AssignedUser = createSlice({
  name: 'AssignedUser',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [getAllAssigneeUser.fulfilled]: (state, {payload}) => {
      return {...state, assignedUserList: payload.data}
    },
  },
})

export const getAllUserAssignedToStaffList = (state: any) => state?.AssignedUser?.assignedUserList

export default AssignedUser.reducer
